"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    getGoogleMapsGeocoding: ()=>getGoogleMapsGeocoding,
    useGoogleMapsGeocoding: ()=>useGoogleMapsGeocoding,
    getOpenStreetMapGeocoding: ()=>getOpenStreetMapGeocoding,
    useOpenStreetMapGeocoding: ()=>useOpenStreetMapGeocoding
});
const _reactQuery = require("react-query");
const _ = require("../..");
const getGoogleMapsGeocoding = (queryParams)=>{
    return _.api.get(`wallet/v1/geofence?latitude=${queryParams.latitude}&longitude=${queryParams.longitude}&service=googleMaps`);
};
const useGoogleMapsGeocoding = (queryOptions = {})=>{
    return (0, _reactQuery.useMutation)((queryParams)=>getGoogleMapsGeocoding(queryParams), {
        ...queryOptions
    });
};
const getOpenStreetMapGeocoding = (queryParams)=>{
    return _.api.get(`wallet/v1/geofence?latitude=${queryParams.latitude}&longitude=${queryParams.longitude}`);
};
const useOpenStreetMapGeocoding = (queryOptions = {})=>{
    return (0, _reactQuery.useMutation)((queryParams)=>getOpenStreetMapGeocoding(queryParams), {
        ...queryOptions
    });
};
